import { ReportHandler } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Create a single performance observer for all metrics to optimize performance
      const reportAll = (metric: any) => {
        console.log(metric);
        onPerfEntry(metric);
      };

      getCLS(reportAll); // Cumulative Layout Shift
      getFID(reportAll); // First Input Delay
      getFCP(reportAll); // First Contentful Paint
      getLCP(reportAll); // Largest Contentful Paint
      getTTFB(reportAll); // Time to First Byte
    })
    .catch(console.error);
  }
};

export default reportWebVitals;
